const IssuersActionTypes = {
    FETCH_ISSUERS_START: "FETCH_ISSUERS_START",
    FETCH_ISSUERS_SUCCESS: "FETCH_ISSUERS_SUCCESS",
    FETCH_ISSUERS_FAILURE: "FETCH_ISSUERS_FAILURE",
};

export default IssuersActionTypes;
